import api from "./ApiClient";

const BASE_PATH = '/foodz/api/v1/financeiro';

class FinancialService {
  static async getClientsWithOutstandingBalance() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/clientesDevedores`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async getPaymentsReceived() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/checarPagamentosRecebidos`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async getOustandingPayments() {
    const clientCode = sessionStorage.getItem('clientCode');
    const login = sessionStorage.getItem('login');
    const response = await api.get(
      `${BASE_PATH}/checarPendencias`,
      { params: { clientCode, searchInput: login } }
    );
    return response.data;
  }

  static async getStatisticsOfPaymentMethods(startDate, endDate) {
    // Check if it's a legacy keyword ('day', 'week') or a date string
    const params = new URLSearchParams();
    params.append('clientCode', sessionStorage.getItem('clientCode'));

    // If your backend still supports keywords, logic goes here. 
    // But since we refactored to specific dates:
    params.append('startDate', startDate);
    params.append('endDate', endDate);

    const response = await api.get(`${BASE_PATH}/formasDePagamentoMaisUsadas?${params.toString()}`);
    return response.data;
  };

  static async getTopSellProducts(startDate, endDate) {
    const params = new URLSearchParams();
    params.append('clientCode', sessionStorage.getItem('clientCode'));
    params.append('startDate', startDate);
    params.append('endDate', endDate);

    const response = await api.get(`${BASE_PATH}/produtosMaisVendidos?${params.toString()}`);
    return response.data;
  };

  static async notifyClientDebt(searchInput, client) {
    const response = await api.post(
      '/foodz/api/v1/notificacoes/cobrarSaldoNegativo',
      client,
      { params: { searchInput } }
    );
    return response.data;
  }

  static async openDailyCashFlow(dailyCashFlow) {
    const response = await api.post(
      `${BASE_PATH}`,
      dailyCashFlow
    );
    return response.data;
  }

  static async checkIfOpen(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/checarStatus`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async getIfOpen(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async retrievePartialCashFlow(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/recuperarVendasCaixaAberto`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async closeDailyCashFlow(dailyCashFlow) {
    const response = await api.put(
      `${BASE_PATH}/finalizarFluxoCaixa`,
      dailyCashFlow
    );
    return response.data;
  }

  static async updateRegistry(dailyCashFlow) {
    const response = await api.put(
      `${BASE_PATH}/atualizarCaixa`,
      dailyCashFlow
    );
    return response.data;
  }

  static async addRegistryTransaction(transaction) {
    const response = await api.post(
      `${BASE_PATH}/transacao`,
      transaction
    );
    return response.data;
  }

  static async addRegistryTransactionAndUpdate(transaction, cashFlow) {
    const response = await api.post(
      `${BASE_PATH}/transacaoCaixa`,
      { transaction, cashFlow }
    );
    return response.data;
  }

  static async getRegistryHistory() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/recuperarHistoricoCaixa`,
      { params: { clientCode } }
    );
    return response.data;
  }


  static async getRegistryOrdersHistory() {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/recuperarVendasPorCaixa`,
      { params: { clientCode } }
    );
    return response.data;
  }

  static async getCreditCharges(searchInput) {
    const clientCode = sessionStorage.getItem('clientCode');
    const response = await api.get(
      `${BASE_PATH}/recuperarRecargas`,
      { params: { clientCode, searchInput } }
    );
    return response.data;
  }

  static async getRechargeHistory() {
    const clientCode = sessionStorage.getItem('clientCode');
    const parentLogin = sessionStorage.getItem('login');
    const response = await api.get(
      `${BASE_PATH}/recarga/historico`,
      { params: { clientCode, parentLogin } }
    );
    return response.data;
  }
}

export default FinancialService;